import { all } from "redux-saga/effects"
import { authSaga } from "./authSaga"
import { bomChiTietSaga } from "./bomChiTietSagas"
import { bomSaga } from "./bomSagas"
import { categorySourceSaga } from "./categorySourceSagas"
import { appConfigSaga } from "./common/appConfigSaga"
import { DayoffSaga } from "./dayoffSaga"
import { dictionarySaga } from "./dictionarySagas"
import { dotGuiSagas } from "./dotGuiSagas"
import { dotGuiTBTPSagas } from "./dotGuiTBTPSaga"
import { duKienSagas } from "./duKienSagas"
import { editTBTPHachToanSagas } from "./edit-tbtp/editTBTPHachToanSagas"
import { editTBTPKhoanNopSagas } from "./edit-tbtp/editTBTPKhoanNopSagas"
import { ganMienGiamSagas } from "./ganMienGiamSagas"
import { hachToanCongNoSagas } from "./hachToanCongNoSagas"
import { hinhThucMienGiamSaga } from "./hinhThucMienGiamSagas"
import { hinhThucThanhToanSaga } from "./hinhThucThanhToanSaga"
import { hoanPhiSaga } from "./hoanPhiSaga"
import { hoanTraTienAnSagas } from "./hoanTraTienAnSagas"
import { hocSinhProfileSaga } from "./hocSinhProfileSaga"
import { khoanNopGroupSaga } from "./khoanNopGroupSagas"
import { khoanNopSaga } from "./khoanNopSaga"
import { loaiKhoanNopSaga } from "./loaiKhoanNopSagas"
import { localizedResourceSaga } from "./localized-resource/localizedResourcsSaga"
import { mucThuPhiNgsSagas } from "./mucThuPhiNgsSagas"
import { mucThuPhiSaga } from "./mucThuPhiSagas"
import { nhomKhoanNopSaga } from "./nhomKhoanNopSagas"
import { saleSetSaga } from "./saleSetDichVuSaga"
import { tbtpSagas } from "./tbtpSagas"
import { thuPhiChiTietSagas } from "./thuPhiChiTietSagas"
import { thuPhiSagas } from "./thuPhiSagas"
import { tongHopChiTietSaga } from "./tongHopChiTietSaga"
import { tongHopHocPhiSaga } from "./tongHopHocPhiSaga"
import { tongHopMienGiamSaga } from "./tongHopMienGiamSaga"
import { tongHopSaga } from "./tongHopSaga"
import { hinhThucMienGiamGroupSaga } from "./hinhThucMienGiamGroupSaga"

export default function* rootSaga() {
    yield all([
        authSaga(),
        dictionarySaga(),
        khoanNopSaga(),
        nhomKhoanNopSaga(),
        loaiKhoanNopSaga(),
        khoanNopGroupSaga(),
        categorySourceSaga(),
        mucThuPhiSaga(),
        bomSaga(),
        bomChiTietSaga(),
        tbtpSagas(),
        hinhThucMienGiamSaga(),
        ganMienGiamSagas(),
        hachToanCongNoSagas(),
        editTBTPHachToanSagas(),
        editTBTPKhoanNopSagas(),
        tongHopSaga(),
        tongHopChiTietSaga(),
        thuPhiSagas(),
        thuPhiChiTietSagas(),
        mucThuPhiNgsSagas(),
        duKienSagas(),
        hocSinhProfileSaga(),
        hoanTraTienAnSagas(),
        hoanPhiSaga(),
        saleSetSaga(),
        hinhThucThanhToanSaga(),
        tongHopMienGiamSaga(),
        DayoffSaga(),
        tongHopHocPhiSaga(),
        dotGuiSagas(),
        appConfigSaga(),
        localizedResourceSaga(),
        dotGuiTBTPSagas(),
        hinhThucMienGiamGroupSaga()

    ])

}
